import AchievementTab from '@/components/feature/AchievementTab'

export default function AchievementsPage() {
  return (
    <div className="flex flex-col">
      <AchievementTab />
    </div>
  )
}
